import {
  Component,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  Renderer2,
  AfterContentChecked,
  OnDestroy
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AdminService } from '@approot/services';
import { ProviderQuoteService, TabItem } from '../provider-quote.service';
import { tabStatus } from '@approot/shared';
import { Throttle } from 'lodash-decorators';

@Component({
  selector: 'app-provider-quote-container',
  templateUrl: './provider-quote-container.component.html',
  styleUrls: ['./provider-quote-container.component.scss'],
  animations: [tabStatus]
})
export class ProviderQuoteContainerComponent
  implements OnInit, AfterContentChecked, OnDestroy
{
  constructor(
    private providerQuoteService: ProviderQuoteService,
    private elementRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    private adminService: AdminService,
    private renderer: Renderer2
  ) {}
  public tabs: TabItem[] = [];
  public productInfo;
  public cutOffTimesAndFixingSources;
  public selectedIndex = 0;
  public tabSubjectSubscription: Subscription;
  public ngOnDestroy(): void {
    this.tabSubjectSubscription?.unsubscribe();
  }

  public ngOnInit() {
    this.tabSubjectSubscription = this.providerQuoteService.quotes$.subscribe(
      tabs => {
        if (tabs.length > this.tabs.length) {
          // if more tabs are added
          // make the tab selected be the last one added
          this.selectedIndex = tabs.length - 1;
          this.tabs = tabs.slice() as unknown as TabItem[];
          const nav = this.elementRef.nativeElement.querySelector('#nav');
          const rfqContainerEl =
            this.elementRef.nativeElement.querySelector('.rfq-container');

          setTimeout(() => {
            // scroll all the way to the right
            this.renderer.setProperty(nav, 'scrollLeft', nav.scrollWidth);

            if (this.tabs[this.selectedIndex]?.dimensions?.height) {
              this.renderer.setStyle(
                rfqContainerEl,
                'height',
                this.tabs[this.selectedIndex].dimensions.height + 'px'
              );
            }
          });
        } else {
          this.tabs = tabs.slice() as unknown as TabItem[];
        }
      }
    );
  }

  public ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  public closeWidget() {
    this.providerQuoteService.removeAllTabs();
  }

  @Throttle(1000)
  public get minWidth(): number {
    const smallestWidth = 600;
    const rfqContainerEl =
      this.elementRef.nativeElement.querySelector('.rfq-container');
    if (rfqContainerEl.offsetWidth < smallestWidth) {
      // if the width is less than what it should be in two way mode
      this.renderer.setStyle(rfqContainerEl, 'width', smallestWidth + 'px');
    }
    return smallestWidth;
  }

  public get minHeight(): number {
    return this.tabs[this.selectedIndex]?.minDimensions?.height || 800;
  }

  public switchTabs(index: number) {
    this.selectedIndex = index;
  }

  public removeTab(index: number) {
    if (
      (index === this.selectedIndex &&
        this.selectedIndex === this.tabs.length - 1) ||
      index < this.selectedIndex
    ) {
      // if the tab removed is the current tab, and is the last of the tab list
      this.selectedIndex =
        this.selectedIndex - 1 < 0 ? 0 : this.selectedIndex - 1;
    }
    this.providerQuoteService.removeTabByIndex(index); // remove the tab
  }

  public get isMedusaAccountLoggedIn() {
    return this.adminService.isMedusaAccountLoggedIn;
  }
}
